export class InspectedGrnInfoModel{
    grnId:number
    grnNumber:string
    invoiceNumber:string
    grnItemId:number
    itemName:string
    poId:number
    poQty:number
    acceptedQty:number
    rejectedQty:number
    recievedQty:number
    discountper:number
    discountAmount:number
    taxPer:number
    taxAmount:number
    totalAmount:number
    price:number
    vendorId:number
    vendorName:string
    itemCategoryId:number
    itemCategory:string
    itemId:number
    saleOrderNumber:string
    poNumber:string
    vendorCode:string

    constructor(grnId:number,grnNumber:string,invoiceNumber:string,grnItemId:number,itemName:string,poId:number,poQty:number,acceptedQty:number,rejectedQty:number,recievedQty:number,discountper:number,discountAmount:number,taxPer:number,taxAmount:number,totalAmount:number,price:number,vendorId:number,vendorName:string,itemCategoryId:number,itemCategory:string,itemId:number,saleOrderNumber:string,poNumber:string,vendorCode:string){
        this.grnId = grnId
        this.grnNumber = grnNumber
        this.invoiceNumber = invoiceNumber
        this.grnItemId = grnItemId
        this.itemName = itemName
        this.poId = poId
        this.poQty = poQty
        this.acceptedQty = acceptedQty
        this.rejectedQty = rejectedQty
        this.recievedQty = recievedQty
        this.discountper = discountper
        this.discountAmount = discountAmount
        this.taxPer = taxPer
        this.taxAmount = taxAmount
        this.totalAmount = totalAmount
        this.price = price
        this.vendorId = vendorId
        this.vendorName = vendorName
        this.itemCategoryId = itemCategoryId
        this.itemCategory = itemCategory
        this.itemId = itemId
        this.saleOrderNumber = saleOrderNumber
        this.poNumber = poNumber
        this.vendorCode = vendorCode
    }

}